import {
  Component,
  Input,
  TemplateRef,
  ViewChild,
  ElementRef,
  forwardRef,
} from "@angular/core";
import { ToolBarToolComponent } from "@progress/kendo-angular-toolbar";
import { KENDO_LABEL } from "@progress/kendo-angular-label";
import { KENDO_ICONS } from "@progress/kendo-angular-icons";
import { ICON_MAP } from "../../../app.const";

@Component({
  standalone: true,
  providers: [
    {
      provide: ToolBarToolComponent,
      useExisting: forwardRef(() => ToolboxTypeComponent),
    },
  ],
  selector: "app-toolbox-type",
  imports: [KENDO_LABEL, KENDO_ICONS],
  template: `
    <ng-template #toolbarTemplate>
      <span #toolbarElement>
        <kendo-icon
          style="font-size: 16px; padding-right: 5px;"
          [name]="iconName"
        ></kendo-icon>
        <kendo-label [text]="type"> </kendo-label>
      </span>
    </ng-template>
  `,
})
export class ToolboxTypeComponent extends ToolBarToolComponent {
  @Input() public type!: string;

  @ViewChild("toolbarTemplate", { static: true })
  declare public toolbarTemplate: TemplateRef<unknown>;
  @ViewChild("toolbarElement", { static: false })
  public toolbarElement!: ElementRef;

  public value!: string;

  constructor() {
    super();
  }

  get iconName(): string {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    return ICON_MAP[this.type] ?? "file";
  }
}
